import { useEffect } from "react";
import {
  Hospital, Stethoscope, FlaskConical, Pill, DollarSign, RefreshCw,
  Search, Clock, MessageCircle, Phone, XCircle, Monitor, Bell, Calendar,
  BarChart3, UserCheck, Package, Link, CreditCard, FileText, AlertTriangle,
  CalendarCheck, MessageSquare, Database, Circle, TrendingUp, X,
} from "lucide-react";
import PanelQuiebres from "@/components/pipeline/PanelQuiebres";
import PanelDetalle from "@/components/pipeline/PanelDetalle";
import PanelAcciones from "@/components/pipeline/PanelAcciones";

const iconMap = {
  Hospital, Stethoscope, FlaskConical, Pill, DollarSign, RefreshCw,
  Search, Clock, MessageCircle, Phone, XCircle, Monitor, Bell, Calendar,
  BarChart3, UserCheck, Package, Link, CreditCard, FileText, AlertTriangle,
  CalendarCheck, MessageSquare, Database, Circle, TrendingUp,
};

export default function StageDrawer({ stage, onClose, applyFilters }) {
  const isOpen = stage != null;

  // Close on ESC key
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  // Prevent body scroll when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  const Icon = stage ? (iconMap[stage.icono] || Circle) : Circle;

  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 z-40 bg-black/30 backdrop-blur-sm transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Drawer panel */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label={stage ? `Detalle etapa ${stage.nombre}` : undefined}
        className={`fixed inset-y-0 right-0 z-50 w-full max-w-lg bg-white shadow-2xl overflow-y-auto transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {stage && (
          <>
            {/* Header */}
            <div className="sticky top-0 z-10 bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div
                  className="h-10 w-10 rounded-xl flex items-center justify-center text-white shadow-md"
                  style={{ backgroundColor: stage.color }}
                >
                  <Icon className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                    Etapa {stage.id}
                  </div>
                  <div className="text-lg font-bold text-slate-900">{stage.nombre}</div>
                </div>
              </div>
              <button
                onClick={onClose}
                className="h-9 w-9 rounded-xl bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition cursor-pointer"
                aria-label="Cerrar panel"
              >
                <X className="w-4 h-4 text-slate-500" />
              </button>
            </div>

            {/* Body — 3 panels stacked */}
            <div className="space-y-6 p-6">
              <PanelQuiebres quiebres={stage.quiebres} color={stage.color} />
              <PanelDetalle subEtapas={stage.sub_etapas} applyFilters={applyFilters} />
              <PanelAcciones acciones={stage.acciones} color={stage.color} />
            </div>
          </>
        )}
      </div>
    </>
  );
}
